export const getCenterFromPolyline = (positions) => {
  const geometry = new window.H.geo.LineString();
  positions.forEach(({ lat, lng }) => {
    geometry.pushLatLngAlt(lat, lng);
  });
  return geometry.getBoundingBox().getCenter();
};
export const getCenterFromPolylines = (polylines) => {
  const geometry = new window.H.geo.LineString();
  polylines.forEach( positions => {
    positions.forEach(({ lat, lng }) => {
      geometry.pushLatLngAlt(lat, lng);
    });
  })
  return geometry.getBoundingBox().getCenter();
};
export const getBBoxFromPolyline = (positions) => {
  const geometry = new window.H.geo.LineString();
  positions.forEach(({ lat, lng }) => {
    geometry.pushLatLngAlt(lat, lng);
  });
  return geometry.getBoundingBox();
};
export const getBBoxFromPolylines = (polylines) => {
  const geometry = new window.H.geo.LineString();
  polylines.forEach( positions => {
    positions.forEach(({ lat, lng }) => {
      geometry.pushLatLngAlt(lat, lng);
    });
  })
  return geometry.getBoundingBox();
};